import { CommonModule } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse, ProperHttpParamEncoder } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ContentTranslationModel } from 'app/generated/backend/content/api/content-translation-model';

@Injectable()
export class ContentTranslationHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	get(
		languageIso2: string,
		uri: string,
		access: number,
		templateName: string
	): Observable<JsonResourceResponse<ContentTranslationModel>> {
		let params = new HttpParams({ encoder: new ProperHttpParamEncoder() });
		if (languageIso2!==null && languageIso2!==undefined) {
			params = params.set('languageIso2', languageIso2);
		}
		if (uri!==null && uri!==undefined) {
			params = params.set('uri', uri);
		}
		if (access!==null && access!==undefined) {
			params = params.set('access', access.toString());
		}
		if (templateName!==null && templateName!==undefined) {
			params = params.set('templateName', templateName);
		}
		return this.http.get<JsonResourceResponse<ContentTranslationModel>>('api/content/content/translation', { params }).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		ContentTranslationHandlerService
	]
})
export class ContentTranslationHandlerModule { }
